import React, { useState } from "react";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import PricingSection from "./components/PricingSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

const LandingPage = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	return (
		<div
			className="font-sans"
			style={{ backgroundColor: "white" }}>
			<Navigation
				isMenuOpen={isMenuOpen}
				setIsMenuOpen={setIsMenuOpen}
			/>
			<HeroSection />
			<FeaturesSection />
			<PricingSection />
			<ContactSection />
			<Footer />
		</div>
	);
};

export default LandingPage;
